import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronLeftOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6 12 8 8 1.273-1.273L8.546 12l6.727-6.727L14 4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ChevronLeftOutlinedSize24Glyph.displayName = 'ChevronLeftOutlinedSize24Glyph';
